import classNames from "classnames";

/**
 * `circleData[i][j]` = For `i` number of circles, this is the the styling of the circle at a distance
 * of `j` from the active circle.
 */
const circleData = [
  null,
  [
    {
      diameter: 16,
      color: "#ffffff",
    },
  ],
  [
    {
      diameter: 16,
      color: "#ffffff",
    },
    {
      diameter: 4,
      color: "#BABABA",
    },
  ],
  [
    {
      diameter: 16,
      color: "#ffffff",
    },
    {
      diameter: 10,
      color: "#E6E6E6",
    },
    {
      diameter: 4,
      color: "#BABABA",
    },
  ],
  [
    {
      diameter: 16,
      color: "#ffffff",
    },
    {
      diameter: 12,
      color: "#E6E6E6",
    },
    {
      diameter: 8,
      color: "#BCBCBC",
    },
    {
      diameter: 4,
      color: "#909090",
    },
  ],
  [
    {
      diameter: 16,
      color: "#ffffff",
    },
    {
      diameter: 14,
      color: "#E6E6E6",
    },
    {
      diameter: 10,
      color: "#BCBCBC",
    },
    {
      diameter: 8,
      color: "#909090",
    },
    {
      diameter: 4,
      color: "#666666",
    },
  ],
];

function TestimonialBrowse({
  onOffset,
  numberOfCircles,
  activeCircle,
  className,
}) {
  function getStyleForOffset(offset) {
    return {
      width: circleData[numberOfCircles][offset].diameter,
      height: circleData[numberOfCircles][offset].diameter,
      backgroundColor: circleData[numberOfCircles][offset].color,
    };
  }

  const circles = [];
  for (let i = 0; i < numberOfCircles; i++) {
    const signedOffset = i - activeCircle;
    circles.push(
      <div
        key={i}
        style={getStyleForOffset(Math.abs(signedOffset))}
        className="rounded-full mx-0.5 cursor-pointer testimonial-browse-circle"
        onClick={() => {
          onOffset(signedOffset);
        }}
      />
    );
  }

  return (
    <div
      className={classNames(
        "flex flex-row justify-center py-4 mt-3",
        className
      )}
    >
      {numberOfCircles > 1 && (
        <button
          onClick={() => {
            onOffset(-1);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 23 23"
            fill="black"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="11.5"
              cy="11.5"
              r="11"
              transform="rotate(-180 11.5 11.5)"
              stroke="white"
            />
            <path
              d="M8.84716 16.6022L4.85795 12.4261C4.61932 12.1954 4.5 11.8812 4.5 11.5352C4.5 11.1892 4.61932 10.8789 4.85795 10.6443L8.84716 6.45223C9.32045 5.95507 10.092 5.95507 10.5653 6.45223C11.0386 6.94939 11.0386 7.7528 10.5653 8.24996L8.6483 10.2545H17.279C17.9551 10.2545 18.5 10.8233 18.5 11.5272C18.5 12.2312 17.9551 12.8 17.283 12.8H8.65227L10.5693 14.8045C11.0426 15.3017 11.0426 16.1051 10.5693 16.6022C10.092 17.0994 9.32443 17.0994 8.84716 16.6022Z"
              fill="white"
            />
          </svg>
        </button>
      )}
      <div className="w-[30%] flex items-center justify-center mx-2">
        {circles}
      </div>
      {numberOfCircles > 1 && (
        <button
          onClick={() => {
            onOffset(1);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 23"
            fill="black"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="11.5" r="11" stroke="white" />
            <path
              d="M14.6528 6.39777L18.642 10.5739C18.8807 10.8046 19 11.1188 19 11.4648C19 11.8108 18.8807 12.1211 18.642 12.3557L14.6528 16.5478C14.1795 17.0449 13.408 17.0449 12.9347 16.5478C12.4614 16.0506 12.4614 15.2472 12.9347 14.75L14.8517 12.7455H6.22102C5.54489 12.7455 5 12.1767 5 11.4728C5 10.7688 5.54489 10.2 6.21705 10.2H14.8477L12.9307 8.1955C12.4574 7.69834 12.4574 6.89493 12.9307 6.39777C13.408 5.90061 14.1756 5.90061 14.6528 6.39777Z"
              fill="white"
            />
          </svg>
        </button>
      )}
    </div>
  );
}

export default TestimonialBrowse;
